export const getWalkthroughStepLabel = (
  activeItemIndex: number,
  size: number
): string => {
  if (size <= 0) return ''
  const clampedIndex = Math.min(Math.max(activeItemIndex, 0), size - 1)
  return `Walkthrough step ${clampedIndex + 1} of ${size}`
}
